module.exports = __webpack_public_path__ + "img/ic-search-f.226322c1.svg";